import { fft, util } from "fft-js";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      fft: { fft, util },
    },
  };
});
